import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  sync({ target }) {
    if (!target.name?.startsWith("ecosystem[color_palette]")) return
    if (!/^#[0-9A-Fa-f]{6}$/.test(target.value)) return

    const picker = target.type === "color" ? target : target.previousElementSibling
    const text = picker.nextElementSibling
    picker.value = target.value
    text.value = target.value.toUpperCase()

    const preview = text.parentElement.nextElementSibling
    if (preview?.classList.contains("h-6")) {
      preview.style.backgroundColor = target.value
    }
  }
}
